import styled from "styled-components"
import { IconButton } from "../../layout/IconButton"

export const ModalAction = styled(IconButton).attrs({
  tooltip: false,
})`
  margin: 0 -8px;
`
